import { StackItem, VStack } from "@/components/Elements/Layouts/Stack";
import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";

export const Layout: React.FC = () => {
  return (
    <VStack fullScreen>
      <Header />
      <StackItem flex backgroundColor="#e4e4e4">
        <Outlet />
      </StackItem>
      <Header />
    </VStack>
  );
};

export default Layout;
